export default "__VITE_ASSET__5b8cdc1d__"